import { render, staticRenderFns } from "./SlCustomerDetailDefaulter.vue?vue&type=template&id=c34bbfe8&lang=pug&"
import script from "./SlCustomerDetailDefaulter.vue?vue&type=script&lang=js&"
export * from "./SlCustomerDetailDefaulter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SlCustomerDetailDefaulter.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
